import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    color: "var(--color-text-secondary, rgba(0, 0, 0, 0.7))",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "var(--color-action-primary, #239FC6)",
  },
  "& .MuiInputBase-input": {
    color: "var(--color-text-primary, #1A1A2E)",
  },
  "& .MuiInputBase-input::placeholder": {
    opacity: 0.85,
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "var(--color-bg-card, #FFFFFF)",
    borderRadius: "var(--radius-sm, 4px)",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-border-subtle, rgba(0, 0, 0, 0.12))",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-border-default, rgba(0, 0, 0, 0.16))",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--color-action-primary, #239FC6)",
      borderWidth: 1.5,
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
});

const AppTextField = React.forwardRef(function AppTextField(
  {
    variant = "outlined",
    size = "small",
    InputLabelProps,
    ...props
  },
  ref
) {
  return (
    <StyledTextField
      ref={ref}
      variant={variant}
      size={size}
      InputLabelProps={{
        ...InputLabelProps,
      }}
      {...props}
    />
  );
});

export default AppTextField;
